module.exports = __webpack_public_path__ + "f0b9237f42183f72200e16443e5ba227.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/3/Assets/img5.jpeg
// module id = 1331
// module chunks = 0